import { Observable } from 'rxjs';
import { SpendTypeRepository } from '../domain/spend_type/repository';
import { SpendType } from '../domain/spend_type/model';
import HttpClient from '../utils/http-client';

export class SpendTypeRepositoryImplementation extends SpendTypeRepository {
  private httpClient: HttpClient;

  constructor() {
    super();
    this.httpClient = new HttpClient("", "");
  }

  createSpendType(spendType: Partial<SpendType>, companyId?: string | number): Observable<SpendType> {
    const client = companyId ? new HttpClient("", String(companyId)) : this.httpClient;
    return client.post('/spends/spend_type', spendType);
  }

  getSpendType(id: number): Observable<any> {
    return this.httpClient.get(`/spends/spend_type/${id}`);
  }

  getSpendTypes(page: number, limit: number): Observable<any> {
    return this.httpClient.get(`/spends/spend_type?page=${page}&limit=${limit}`);
  }

  updateSpendType(id: number, spendType: Partial<SpendType>): Observable<SpendType> {
    return this.httpClient.put(`/spends/spend_type/${id}`, spendType);
  }

  deleteSpendType(id: number): Observable<void> {
    return this.httpClient.delete(`/spends/spend_type/${id}`);
  }

  matchSpendTypes(items: Array<{ description: string }>): Observable<any> {
    return this.httpClient.post('/spends/spend_type/match', { items });
  }
}
